// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"10":"91b72130","272":"9e9abe75"}[chunkId] + ".js";
};